import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { getMyAvailabilityConstants } from 'src/redux/actions/constant';
import ptoRequestServices from 'src/services/apiServices/my-availability-services/pto-request-service';

const {
  GET_MY_AVAILABILITY_LOADING,
  GET_ALL_PTO_REQUEST,
  GET_ALL_PTO_SUCCESS,
  GET_ALL_PTO_FAILURE
} = getMyAvailabilityConstants;

function* getAllRequestPto(action: any): SagaReturnType<any> {
  try {
    const response = yield call(ptoRequestServices.getAllPtoRequest, action.providerId);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_PTO_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_PTO_FAILURE, payload: error });
  }
}

function* getAllPtoRequestSaga() {
  yield takeEvery(GET_ALL_PTO_REQUEST, getAllRequestPto);
}

export default getAllPtoRequestSaga;
